module.exports = __webpack_public_path__ + "img/auto1.8c15a66a.jpg";